/** Normalize POST /getOrders response (axios envelope or Flask json string body). */
export function parseHotelGetOrdersEnvelope(axiosLike) {
  const httpStatus = axiosLike?.status ?? null;
  const rawData = axiosLike?.data;
  let body;
  if (typeof rawData === "string") {
    const t = rawData.trim();
    if (!t) body = {};
    else {
      try {
        body = JSON.parse(t);
      } catch {
        body = {};
      }
    }
  } else if (rawData && typeof rawData === "object") {
    body = rawData;
  } else {
    body = {};
  }
  const orders = Array.isArray(body.orders) ? body.orders : [];
  const msg = String(body.message || "").toLowerCase();
  const responseStatus = body.status ?? null;

  let hotelsBarrier = null;
  if (httpStatus === 403 && body.error === "email_session_mismatch") {
    hotelsBarrier = {
      kind: "email_session_mismatch",
      message:
        "כתובת האימייל בבקשה לא תואמת לסוכן של הסשן המחובר. התנתקו מהמערכת והתחברו מחדש, או פנו לתמיכה.",
    };
  } else if (
    httpStatus === 403 &&
    (msg.includes("search_hotels") || msg.includes("search hotels entitlement"))
  ) {
    hotelsBarrier = {
      kind: "search_hotels_entitlement",
      message:
        "אין הרשאה לצפייה בהזמנות מלון — יש לשייך לסוכן חבילת שירות מתאימה.",
    };
  } else if (httpStatus === 400 && body.error === "unknown_agent_email") {
    hotelsBarrier = {
      kind: "unknown_agent_email",
      message:
        "אימייל סוכן לא נמצא במערכת. בדקו שהתחברתם עם המשתמש הנכון.",
    };
  } else if (
    !hotelsBarrier &&
    (responseStatus === "fail" || body.error) &&
    orders.length === 0
  ) {
    hotelsBarrier = {
      kind: "api_query_failed",
      message:
        body.message ||
        body.error ||
        "לא ניתן לטעון הזמנות מלון. נסו שוב או פנו לתמיכה.",
    };
  }

  return {
    httpStatus,
    responseStatus,
    responseError: body.error ?? null,
    responseMessage: body.message ?? null,
    rawApiResponseCount: orders.length,
    orders,
    hotelsBarrier,
  };
}

export function buildAgentHotelOrdersLoadTrace({
  userInfo,
  userDetails,
  endpoint,
  queryKey,
  loadingPhase,
  error,
  responseCount,
}) {
  return {
    userEmail: userInfo?.email ?? null,
    userId: userInfo?.id ?? null,
    role: String(userDetails?.role ?? "").trim() || null,
    endpoint,
    queryKey,
    loadingPhase,
    error: error ?? null,
    responseCount: Number.isFinite(Number(responseCount)) ? Number(responseCount) : null,
  };
}
